import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";

const GASSearch = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [results, setResults] = useState([]);

  // Dummy search function
  const handleSearch = () => {
    setResults([
      { id: 1, agenda: "Vendor Meeting", date: "2025-01-10", outcome: "Positive" },
      { id: 2, agenda: "Team Sync", date: "2025-01-12", outcome: "Neutral" },
    ]);
  };

  return (
    <div className="min-h-screen bg-black text-cyan-400 px-4 py-6">
      <h2 className="text-lg font-semibold mb-4">Search Appointments</h2>

      {/* Search Box */}
      <div className="flex gap-2 mb-4">
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          placeholder="Enter Appointment Agenda or ID"
          className="flex-1 p-2 rounded border border-cyan-600 bg-black text-cyan-400 placeholder-gray-500"
        />
        <button
          onClick={handleSearch}
          className="px-2 py-2 bg-cyan-600 hover:bg-cyan-500 rounded flex items-center gap-1 w-8"
        >
          <FontAwesomeIcon icon={faMagnifyingGlass} />
        </button>
      </div>

      {/* Results Table */}
      <div className="overflow-x-auto">
        <table className="w-full text-sm border border-cyan-700 rounded">
          <thead>
            <tr className="bg-black/50">
              <th className="border px-2 py-1">ID</th>
              <th className="border px-2 py-1">Agenda</th>
              <th className="border px-2 py-1">Date</th>
              <th className="border px-2 py-1">Outcome</th>
            </tr>
          </thead>
          <tbody>
            {results.length > 0 ? (
              results.map((r) => (
                <tr key={r.id} className="hover:bg-black/30">
                  <td className="border px-2 py-1">{r.id}</td>
                  <td className="border px-2 py-1">{r.agenda}</td>
                  <td className="border px-2 py-1">{r.date}</td>
                  <td className="border px-2 py-1">{r.outcome}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={4} className="text-center py-4 text-gray-500">
                  No results found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GASSearch;
